import { LazyRequestAccessConfirmationModal } from './LazyRequestAccessConfirmationModal';
import React from 'react';
import { Board } from './RequestAccessConfirmationModal';
import Dialog from 'app/scripts/views/lib/dialog';

export const OpenAutoInviteDialog = (inviteMemberId: string, board: Board) => {
  Dialog.show({
    reactElement: (
      <LazyRequestAccessConfirmationModal
        board={board}
        idMember={inviteMemberId}
        onClose={Dialog.hide}
      />
    ),
    maxWidth: 600,
    displayType: 'auto-invite-dialog',
  });
};
